var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJpLocation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "outline/location-marker"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8863 5.62603C14.053 2.79273 9.45933 2.79273 6.62603 5.62603C3.79273 8.45933 3.79273 13.053 6.62603 15.8863L10.8725 20.1328C11.3608 20.6211 12.1516 20.6211 12.6403 20.1324L16.8863 15.8863C19.7196 13.053 19.7196 8.45933 16.8863 5.62603ZM5.56462 4.56462C8.98412 1.14513 14.5282 1.14513 17.9477 4.56462C21.3672 7.98412 21.3672 13.5282 17.9477 16.9477L13.7017 21.1938C12.6272 22.2683 10.886 22.2691 9.8111 21.1942L5.56462 16.9477C2.14513 13.5282 2.14513 7.98412 5.56462 4.56462ZM11.7562 8.50458C10.5127 8.50458 9.50458 9.51265 9.50458 10.7562C9.50458 11.9997 10.5127 13.0078 11.7562 13.0078C12.9997 13.0078 14.0078 11.9997 14.0078 10.7562C14.0078 9.51265 12.9997 8.50458 11.7562 8.50458ZM8.00353 10.7562C8.00353 8.68364 9.68364 7.00353 11.7562 7.00353C13.8287 7.00353 15.5088 8.68364 15.5088 10.7562C15.5088 12.8287 13.8287 14.5088 11.7562 14.5088C9.68364 14.5088 8.00353 12.8287 8.00353 10.7562Z",
    fill: "#70758F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJpLocation);
export default __webpack_public_path__ + "static/media/jp-location.9c6c73d62d3d0dcc05852aae178d3393.svg";
export { ForwardRef as ReactComponent };